export const COMBOS = [
{
  id: 0,
  name: 'Keres-Fischer, Candidates Yugoslavia 1959',
  featured: true,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'8/8/2P5/3K1k2/2R3p1/2q5/8/8',
    1:'8/8/2P5/3Kqk2/2R3p1/8/8/8',
  },
  comments:{
    0:'Keres-Bobby Fischer, Black to move.',
    1:'1...Qe5+. It\'s checkmate!',
  },
  solution:
  [
    {
      startrow:'6',
      startcol:'3',
      endrow:'4',
      endcol:'5'
    }
  ]
},
{
  id: 1,
  name: 'Letelier-Bobby Fischer, Leipzig 1960',
  featured: true,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'6k1/pp4bp/2n2np1/5p2/2P2K2/5BN1/PP5P/RQ6',
    1:'6k1/pp5p/2n2npb/5p2/2P2K2/5BN1/PP5P/RQ6',
  },
  comments:{
    0:'Letelier-Bobby Fischer, Black to move.',
    1:'1...Bh6+. It\'s checkmate! White resigned before allowing the checkmate.',
  },
  solution:
  [
    {
      startrow:'2',
      startcol:'7',
      endrow:'3',
      endcol:'8'
    }
  ]
},
{
  id: 2,
  name: 'Surgies-Bobby Fischer, Milwakee 1957',
  featured: true,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'4r1k1/1p3p1p/2pR2pB/p7/P1P5/1P4Pb/3R1K1P/4r3',
    1:'4r1k1/1p3p1p/2pR2pB/p7/P1P5/1P4Pb/3R1K1P/5r2',
  },
  comments:{
    0:'Surgies-Bobby Fischer, Black to move.',
    1:'1...Rf1+. It\'s checkmate!',
  },
  solution:
  [
    {
      startrow:'8',
      startcol:'5',
      endrow:'8',
      endcol:'6'
    }
  ]
},
{
  id: 3,
  name: 'Fischer - Jones, Detroit Simul 1964',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'r1b1qknr/ppppb2p/2n2p2/7Q/2BPP3/8/PPP3PP/RNB1K1NR',
    1:'r1b1qknr/ppppb2p/2n2p1B/7Q/2BPP3/8/PPP3PP/RN2K1NR',
  },
  comments:{
    0:'Bobby Fischer - Jones, White to move.',
    1:'1.Bh6+. It\'s checkmate after 1...Nxh6 2.Qxh6#.',
  },
  solution:
  [
    {
      startrow:'8',
      startcol:'3',
      endrow:'3',
      endcol:'8'
    }
  ]
},
{
  id: 4,
  name: 'Fischer - Pilnik, Santiago 1959',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'6rk/pp5n/5PpQ/3q2P1/4p3/2P3R1/PP4RK/8',
    1:'6rk/pp5Q/5Pp1/3q2P1/4p3/2P3R1/PP4RK/8',
  },
  comments:{
    0:'Bobby Fischer - Pilnik, White to move.',
    1:'1.Qxh7+. It\'s checkmate after 1...Kxh7 2.Rh3#.',
  },
  solution:[
    {
      startrow:'3',
      startcol:'8',
      endrow:'2',
      endcol:'8',
    }
  ]
},
{
  id: 5,
  name: 'Fischer - Euwe, Leipzig Olympiad 1960',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'1B6/7p/P3p3/5pp1/3b4/2k2P2/5P1P/3K4',
    1:'8/7p/P3p3/4Bpp1/3b4/2k2P2/5P1P/3K4',
  },
  comments:{
    0:'Bobby Fischer - Euwe, White to move.',
    1:'1.Be5. The pin prevents Black from stopping the a-pawn from Queening.',
  },
  solution:[
    {
      startrow:'1',
      startcol:'2',
      endrow:'4',
      endcol:'5',
    }
  ]
},
{
  id: 6,
  name: 'Aaron - Fischer, Stockholm Interzonal 1962',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'6k1/1q3p1p/b3p1p1/3p4/P1r2P2/2N5/1P1R1QPP/6K1',
    1:'6k1/1q3p1p/b3p1p1/3p4/P4P2/2r5/1P1R1QPP/6K1'
  },
  comments:{
    0:'Aaron - Bobby Fischer, Black to move.',
    1:'1...Rxc3. Taking the Rook with 2.bxc3 results in mate after 2...Qb1+.',
  },
  solution:[
    {
      startrow:'5',
      startcol:'3',
      endrow:'6',
      endcol:'3',
    }
  ]
},
{
  id: 7,
  name: 'Fischer - Benko, Curacao Candidates 1962',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'r6k/pp1b2p1/3Np2p/r3P3/1q1p1PRQ/2nB4/2PK1B1P/4R3',
    1:'r6k/pp1b2p1/3Np2Q/r3P3/1q1p1PR1/2nB4/2PK1B1P/4R3'
  },
  comments:{
    0:'Bobby Fischer - Benko, White to move.',
    1:'1.Qxh6+. Taking the Queen with 1...gxh6 results in mate after 2.Nf7+.',
  },
  solution:[
    {
      startrow:'5',
      startcol:'8',
      endrow:'3',
      endcol:'8',
    }
  ]
},
{
  id: 8,
  name: 'Fischer - Pachman, Leipzig Olympiad 1960',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution by moving the correct piece.',
  diagrams:{
    0:'6r1/2q2kp1/1p2ppQp/pP6/2P2P2/1P4RP/6P1/6K1',
    1:'5kr1/2q3p1/1p2ppQp/pP6/2P2P2/1P4RP/6P1/6K1'
  },
  comments:{
    0:'Bobby Fischer - Pachman, You are playing against Fischer! What is the correct move for Black to defend?',
    1:'1...Kf8. After this correct move, White only has a small but steady advantage after 2.Re3. Instead Black played 1...Ke7? and resigned after 2.Qxg7+! Rxg7 3.Rxg7+ Kd6 4.Rxc7 Kxc7 5.g4 as Black can\'t stop Fischer from forming a passed pawn on both the kingside and queenside.',
  },
  solution:[
    {
      startrow:'2',
      startcol:'6',
      endrow:'1',
      endcol:'6',
    }
  ]
},
{
  id: 9,
  name: 'Souza Mendes - Fischer, Mar del Plata 1959',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution for Black by moving the correct piece. You will need to find 2 moves.',
  diagrams:{
    0:'1r5k/7p/3p4/3PpB2/K3P3/1P1bbR1N/1P5P/8',
    1:'r6k/7p/3p4/3PpB2/K3P3/1P1bbR1N/1P5P/8',
    2:'r6k/7p/3p4/3PpB2/1K2P3/1P1bbR1N/1P5P/8',
    3:'r6k/7p/3p4/3PpB2/1K2P3/1P1b1R1N/1P1b3P/8'
  },
  comments:{
    0:'Souza Mendes - Fischer, Mar del Plata 1959, Black to move.',
    1:'1...Ra8+. Very good!',
    2:'2.Kb4. Here White actually resigned. What move would you play for Black?',
    3:'2...Bd2+. Checkmate!',
  },
  solution:[
    {
      startrow:'1',
      startcol:'2',
      endrow:'1',
      endcol:'1',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'6',
      startcol:'5',
      endrow:'7',
      endcol:'4',
    },
  ]
},
{
  id: 10,
  name: 'Fischer-Gligorich, Yugoslavia 1970',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 2 moves.',
  diagrams:{
    0:'r1nq1n2/3b2k1/p2p1p1R/Pp1Pp1p1/1Pp1P1P1/2P1BPN1/2BQ2K1/8',
    1:'r1nq1n2/3b2k1/p2p1R2/Pp1Pp1p1/1Pp1P1P1/2P1BPN1/2BQ2K1/8',
    2:'r1nq1n2/3b4/p2p1k2/Pp1Pp1p1/1Pp1P1P1/2P1BPN1/2BQ2K1/8',
    3:'r1nq1n2/3b4/p2p1k2/Pp1Pp1B1/1Pp1P1P1/2P2PN1/2BQ2K1/8'
  },
  comments:{
    0:'Fischer-Gligorich, Yugoslavia 1970, White to move.',
    1:'1.Rxf6!. Very good!',
    2:'1...Kxf6. If instead 1...Qxf6, then 2.Nh5+ forks the King and Queen. Here Black actually resigned. What move would you play for White?',
    3:'2.Bxg5+. The Black King and Queen are skewered.',
  },
  solution:[
    {
      startrow:'3',
      startcol:'8',
      endrow:'3',
      endcol:'6',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'6',
      startcol:'5',
      endrow:'4',
      endcol:'7',
    },
  ]
},
{
  id: 11,
  name: 'Spassky-Fischer, World Championship 1972',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution for Black by moving the correct piece. You will need to find 2 moves.',
  diagrams:{
    0:'5k2/3b2p1/1p4qp/p1pPp1p1/P1P1Pn2/2P5/2Q3PP/3BB1K1',
    1:'5k2/6p1/1p4qp/p1pPp1p1/b1P1Pn2/2P5/2Q3PP/3BB1K1',
    2:'5k2/6p1/1p4qp/p1pPp1p1/Q1P1Pn2/2P5/6PP/3BB1K1',
    3:'5k2/6p1/1p5p/p1pPp1p1/Q1P1qn2/2P5/6PP/3BB1K1'
  },
  comments:{
    0:'Spassky-Fischer, World Championship 1972, Black to move.',
    1:'1...Bxa4!. Very good!',
    2:'2.Qxa4. Here White actually resigned. What move would you play for Black?',
    3:'2...Qxe4. The Bishop on e1 and pawn on g2 are forked.',
  },
  solution:[
    {
      startrow:'2',
      startcol:'4',
      endrow:'5',
      endcol:'1',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'3',
      startcol:'7',
      endrow:'5',
      endcol:'5',
    },
  ]
},
{
  id: 12,
  name: 'Fischer-Sanchez, Santiago 1959',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 2 moves.',
  diagrams:{
    0:'2r5/2P4R/p3kp1p/n3pNpP/1b2P1P1/4B3/5P2/6K1',
    1:'2r5/2P4R/p3kp1p/n3pNpP/1b2P1P1/8/3B1P2/6K1',
    2:'2r5/2P4R/p3kp1p/n3pNpP/4P1P1/8/3b1P2/6K1',
    3:'2r5/2P1R3/p3kp1p/n3pNpP/4P1P1/8/3b1P2/6K1'
  },
  comments:{
    0:'Fischer-Sanchez, Santiago 1959, White to move.',
    1:'1.Bd2!. Very good! Black must either allow checkmate or give up a piece.',
    2:'1...Bxd2. Here Black actually resigned. What move would you play for White?',
    3:'2.Re7. Checkmate!',
  },
  solution:[
    {
      startrow:'6',
      startcol:'5',
      endrow:'7',
      endcol:'4',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'2',
      startcol:'8',
      endrow:'2',
      endcol:'5',
    },
  ]
},
{
  id: 13,
  name: 'Fischer-Fine, Blitz 1963',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 2 moves.',
  diagrams:{
    0:'r1b2rk1/ppqnbppp/2p2n2/4p1N1/2B1P3/8/PPP1QPPP/RNBR2K1',
    1:'r1b2rk1/ppqnbBpp/2p2n2/4p1N1/4P3/8/PPP1QPPP/RNBR2K1',
    2:'r1b3k1/ppqnbrpp/2p2n2/4p1N1/4P3/8/PPP1QPPP/RNBR2K1',
    3:'r1b3k1/ppqnbrpp/2p2n2/4p1N1/2Q1P3/8/PPP2PPP/RNBR2K1'
  },
  comments:{
    0:'Fischer-Fine, Blitz 1963, White to move.',
    1:'1.Bxf7+!. Very good! Black has no good defense.',
    2:'1...Rxf7. Here Black actually resigned. What move would you play for White?',
    3:'2.Qc4. Fischer wins the Rook on f7 with a devastating attack.',
  },
  solution:[
    {
      startrow:'5',
      startcol:'3',
      endrow:'2',
      endcol:'6',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'7',
      startcol:'5',
      endrow:'5',
      endcol:'3',
    },
  ]
},
{
  id: 14,
  name: 'Rivera-Fischer, Varna Olympiad 1962',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 3 moves.',
  diagrams:{
    0:'r4rk1/pbq2ppp/1p2pn2/n1p5/3P4/PBP1P1N1/1B3PPP/2RQ1RK1',
    1:'r4rk1/pb3ppp/1pq1pn2/n1p5/3P4/PBP1P1N1/1B3PPP/2RQ1RK1',
    2:'r4rk1/pb3ppp/1pq1pn2/n1p5/3P4/PBP1PPN1/1B4PP/2RQ1RK1',
    3:'r4rk1/pb3ppp/1p2pn2/nqp5/3P4/PBP1PPN1/1B4PP/2RQ1RK1',
    4:'r4rk1/pb3ppp/1p2pn2/nqp5/B2P4/P1P1PPN1/1B4PP/2RQ1RK1',
    5:'r4rk1/pb3ppp/1p2pn2/n1p5/B2P4/P1P1PPN1/1q4PP/2RQ1RK1'
  },
  comments:{
    0:'Rivera-Fischer, Varna Olympiad 1962.',
    1:'1...Qc6! Very good! The Queen threatens mate on g2.',
    2:'2.f3. What move would you play for Black?',
    3:'2...Qb5. Correct! The Queen skewers the White Bishops',
    4:'3.Ba4. What move would you play for Black?',
    5:'3...Qxb2. White resigned here.',
  },
  solution:[
    {
      startrow:'2',
      startcol:'3',
      endrow:'3',
      endcol:'3',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'3',
      startcol:'3',
      endrow:'4',
      endcol:'2',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'4',
      startcol:'2',
      endrow:'7',
      endcol:'2',
    }
  ]
},
{
  id: 15,
  name: 'Fischer-Durao, Havana olympiad 1966',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 4 moves.',
  diagrams:{
    0:'2nrkb2/5p2/1pr1p1pp/p1p1P3/P1N1NPP1/1RP4R/1P2K2P/8',
    1:'2nrkb2/5p2/1pr1p1pp/N1p1P3/P3NPP1/1RP4R/1P2K2P/8',
    2:'2nrkb2/5p2/2r1p1pp/p1p1P3/P3NPP1/1RP4R/1P2K2P/8',
    3:'2nrkb2/5p2/2r1pNpp/p1p1P3/P4PP1/1RP4R/1P2K2P/8',
    4:'2nr1b2/4kp2/2r1pNpp/p1p1P3/P4PP1/1RP4R/1P2K2P/8',
    5:'2nr1b2/1R2kp2/2r1pNpp/p1p1P3/P4PP1/2P4R/1P2K2P/8',
    6:'2n2b2/1R1rkp2/2r1pNpp/p1p1P3/P4PP1/2P4R/1P2K2P/8',
    7:'2n2b2/3Rkp2/2r1pNpp/p1p1P3/P4PP1/2P4R/1P2K2P/8'
  },
  comments:{
    0:'Fischer-Durao, Havana Olympiad 1966.',
    1:'1.Nxa5!. Very good! The Queen deflects the Black Rook from the back rank.',
    2:'1...bxa5. Here Black actually played 1...Rc7 but later lost. What move would you play for White?',
    3:'2.Nf6+. Check!',
    4:'2...Ke7. The only move.',
    5:'3.Rb7+. Check!',
    6:'3...Rd7. The only move.',
    7:'4.Rxd7. Checkmate!',
  },
  solution:[
    {
      startrow:'5',
      startcol:'3',
      endrow:'4',
      endcol:'1',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'5',
      endrow:'3',
      endcol:'6',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'6',
      startcol:'2',
      endrow:'2',
      endcol:'2',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'2',
      startcol:'2',
      endrow:'2',
      endcol:'4',
    }
  ]
},
{
  id: 16,
  name: 'Reshevsky-Fischer, Palma de Mallorca 1970',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution for Black by moving the correct piece. You will need to find 3 moves.',
  diagrams:{
    0:'4rbk1/3Q1ppp/3p4/3P4/5q2/B7/P5PP/5RK1',
    1:'4rbk1/3Q1ppp/3p4/3P4/3q4/B7/P5PP/5RK1',
    2:'4rbk1/3Q1ppp/3p4/3P4/3q4/B7/P5PP/5R1K',
    3:'4rbk1/3Q1ppp/3p4/3P4/8/B7/P4qPP/5R1K',
    4:'4rbk1/5ppp/3p4/1Q1P4/8/B7/P4qPP/5R1K',
    5:'5bk1/5ppp/3p4/1Q1P4/8/B7/P4qPP/4rR1K'
  },
  comments:{
    0:'Reshevsky-Fischer, Palma de Mallorca 1970, Black to move.',
    1:'1...Qd4+!. Very good!',
    2:'2.Kh1. What move would you play for Black?',
    3:'2...Qf2!. Taking advantage of the weakness of the bankrank.',
    4:'3.Qb5. Here White actually resigned. What move would you play for Black?',
    5:'3...Re1!. Taking advantage of the weakness of the bankrank.'
  },
  solution:[
    {
      startrow:'5',
      startcol:'6',
      endrow:'5',
      endcol:'4',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'4',
      endrow:'7',
      endcol:'6',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'1',
      startcol:'5',
      endrow:'8',
      endcol:'5',
    }
  ]
},
{
  id: 17,
  name: 'Fischer-Weinstein, US Championship 1960',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 3 moves.',
  diagrams:{
    0:'k6r/p4r2/2n1b2p/1R1p4/2p1p1P1/q1P1Q1BB/2P2P1P/1R4K1',
    1:'k6r/p4r2/2n1b2Q/1R1p4/2p1p1P1/q1P3BB/2P2P1P/1R4K1',
    2:'k7/p4r2/2n1b2r/1R1p4/2p1p1P1/q1P3BB/2P2P1P/1R4K1',
    3:'kR6/p4r2/2n1b2r/3p4/2p1p1P1/q1P3BB/2P2P1P/1R4K1',
    4:'kn6/p4r2/4b2r/3p4/2p1p1P1/q1P3BB/2P2P1P/1R4K1',
    5:'kR6/p4r2/4b2r/3p4/2p1p1P1/q1P3BB/2P2P1P/6K1'
  },
  comments:{
    0:'Fischer-Weinstein, US Championship 1960.',
    1:'1.Qxh6!. Very good! The Queen deflects the Black Rook from the back rank.',
    2:'1...Rxh6. Here Black actually resigned. What move would you play for White?',
    3:'2.Rb8. Check!',
    4:'2...Nxb8. The only move.',
    5:'3.Rxb8. Checkmate!',
  },
  solution:[
    {
      startrow:'6',
      startcol:'5',
      endrow:'3',
      endcol:'8',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'4',
      startcol:'2',
      endrow:'1',
      endcol:'2',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'8',
      startcol:'2',
      endrow:'1',
      endcol:'2',
    }
  ]
},
{
  id: 18,
  name: 'Fischer-Miagmasuren, Sousse 1967',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 3 moves.',
  diagrams:{
    0:'2r2qk1/r4p1p/b3pBpQ/n3P2P/p2p3R/P5P1/2p2PB1/R5K1',
    1:'2r2qk1/r4p1Q/b3pBp1/n3P2P/p2p3R/P5P1/2p2PB1/R5K1',
    2:'2r2q2/r4p1k/b3pBp1/n3P2P/p2p3R/P5P1/2p2PB1/R5K1',
    3:'2r2q2/r4p1k/b3pBP1/n3P3/p2p3R/P5P1/2p2PB1/R5K1',
    4:'2r2q2/r4p2/b3pBk1/n3P3/p2p3R/P5P1/2p2PB1/R5K1',
    5:'2r2q2/r4p2/b3pBk1/n3P3/p2pB2R/P5P1/2p2P2/R5K1'
  },
  comments:{
    0:'Fischer-Miagmasuren, Sousse 1967, White to move.',
    1:'1.Qxh7+!. Very good!',
    2:'1...Kxh7. Here Black actually resigned. What move would you play for White?',
    3:'2.hxg6+. Forcing the Black King out into the open.',
    4:'2...Kxg6. The only move. What move would you play for White?',
    5:'3.Be4#. Checkmate!',
  },
  solution:[
    {
      startrow:'3',
      startcol:'8',
      endrow:'2',
      endcol:'8',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'4',
      startcol:'8',
      endrow:'3',
      endcol:'7',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'7',
      startcol:'7',
      endrow:'5',
      endcol:'5',
    },
  ]
},
{
  id: 19,
  name: 'Fischer - Bachiller, Madrid simul 1970',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 5 moves.',
  diagrams:{
    0:'6k1/3N1ppp/p1r5/q3P3/P3R1Q1/2n1B3/5PPP/6K1',
    1:'6k1/5ppp/p1r2N2/q3P3/P3R1Q1/2n1B3/5PPP/6K1',
    2:'7k/5ppp/p1r2N2/q3P3/P3R1Q1/2n1B3/5PPP/6K1',
    3:'7k/5pQp/p1r2N2/q3P3/P3R3/2n1B3/5PPP/6K1',
    4:'8/5pkp/p1r2N2/q3P3/P3R3/2n1B3/5PPP/6K1',
    5:'8/5pkp/p1r2N2/q3P3/P5R1/2n1B3/5PPP/6K1',
    6:'5k2/5p1p/p1r2N2/q3P3/P5R1/2n1B3/5PPP/6K1',
    7:'5kR1/5p1p/p1r2N2/q3P3/P7/2n1B3/5PPP/6K1',
    8:'6R1/4kp1p/p1r2N2/q3P3/P7/2n1B3/5PPP/6K1',
    9:'4R3/4kp1p/p1r2N2/q3P3/P7/2n1B3/5PPP/6K1'
  },
  comments:{
    0:'Fischer - Bachiller, Madrid simul 1970, White to move.',
    1:'1.Nf6+. Very good!',
    2:'1...Kh8. What move would you play for White?',
    3:'2.Qxg7+. Very good! This Queen sacrifice forces checkmate.',
    4:'2...Kxg7. Here Black actually resigned. What move would you play for White?',
    5:'3.Rg4+. The Rook enters the hunt.',
    6:'3...Kf8. What move would you play for White?',
    7:'4.Rg8+. The Rook and Knight combine for a decisive attack.',
    8:'4...Ke7. The only move. What move would you play for White?',
    9:'5.Re8#. Checkmate!'
  },
  solution:[
    {
      startrow:'2',
      startcol:'4',
      endrow:'3',
      endcol:'6',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'7',
      endrow:'2',
      endcol:'7',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'5',
      endrow:'5',
      endcol:'7',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'7',
      endrow:'1',
      endcol:'7',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'1',
      startcol:'7',
      endrow:'1',
      endcol:'5',
    }
  ]
},
{
  id: 20,
  name: 'Fischer - Benko, New York 1965',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 4 moves.',
  diagrams:{
    0:'2qr2k1/6Pn/p4pQ1/1p3P2/2p1Bp1P/2P2P2/PP6/6RK',
    1:'2qrQ1k1/6Pn/p4p2/1p3P2/2p1Bp1P/2P2P2/PP6/6RK',
    2:'2q1r1k1/6Pn/p4p2/1p3P2/2p1Bp1P/2P2P2/PP6/6RK',
    3:'2q1r1k1/6Pn/p4p2/1p1B1P2/2p2p1P/2P2P2/PP6/6RK',
    4:'2q3k1/6Pn/p3rp2/1p1B1P2/2p2p1P/2P2P2/PP6/6RK',
    5:'2q3k1/6Pn/p3Bp2/1p3P2/2p2p1P/2P2P2/PP6/6RK',
    6:'24k1/6Pn/p3qp2/1p3P2/2p2p1P/2P2P2/PP6/6RK',
    7:'24k1/6Pn/p3Pp2/1p6/2p2p1P/2P2P2/PP6/6RK'
  },
  comments:{
    0:'Fischer - Benko, New York 1965, White to move.',
    1:'1.Qe8+. Very good!',
    2:'1...Rxe8. Here Black actually resigned. What move would you play for White?',
    3:'2.Bd5+. Very good! Black must give up his Queen and Rook.',
    4:'2...Re6. The Rook interposes. What move would you play for White?',
    5:'3.Bxe6+. Forking the Black Queen and King.',
    6:'3...Qxe6. The only move. What move would you play for White?',
    7:'4.fxe6. "White has a Rook and two pawns for the Knight; besides this material advantage, he will soon be able to promote one of his advanced pawns."-Fischer'
  },
  solution:[
    {
      startrow:'3',
      startcol:'7',
      endrow:'1',
      endcol:'5',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'5',
      endrow:'4',
      endcol:'4',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'4',
      startcol:'4',
      endrow:'3',
      endcol:'5',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'4',
      startcol:'6',
      endrow:'3',
      endcol:'5',
    }
  ]
},
{
  id: 21,
  name: 'Keres - Fischer, Zagreb 1959',
  featured: false,
  flip: true,
  image: '/assets/images/John1.png',
  description:'Find the solution for Black by moving the correct piece. You will need to find 4 moves.',
  diagrams:{
    0:'2r1r1k1/5p1p/6p1/1B6/3P2Q1/2b3P1/q4P1P/3R1K1R',
    1:'2r1r1k1/5p1p/6p1/1B1q4/3P2Q1/2b3P1/5P1P/3R1K1R',
    2:'2r1B1k1/5p1p/6p1/3q4/3P2Q1/2b3P1/5P1P/3R1K1R',
    3:'2r1B1k1/5p1p/6p1/8/3P2Q1/2b3P1/5P1P/3R1K1q',
    4:'2r1B1k1/5p1p/6p1/8/3P2Q1/2b3P1/4KP1P/3R3q',
    5:'4r1k1/5p1p/6p1/8/3P2Q1/2b3P1/4KP1P/3R3q',
    6:'4r1k1/5p1p/6p1/8/3P2Q1/2bK2P1/5P1P/3R3q',
    7:'4r1k1/5p1p/6p1/8/3P2Q1/3K2P1/5P1P/3Rb2q'
      },
  comments:{
    0:'Keres - Fischer, Zagreb 1959, Black to move.',
    1:'1...Qd5. Double attacking the White Bishop and Rook.',
    2:'2.Bxe8. What move would you play for Black?',
    3:'2...Qxh1+.',
    4:'3.Ke2. The only move. Now what move would you play for Black?',
    5:'3...Rxe8+.',
    6:'4.Kd3. White has achieved his own double attack on the Black Bishop and Queen. How does Black foil this?',
    7:'4...Be1. Here White resigned.',
  },
  solution:[
    {
      startrow:'7',
      startcol:'1',
      endrow:'4',
      endcol:'4',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'4',
      startcol:'4',
      endrow:'8',
      endcol:'8',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'1',
      startcol:'3',
      endrow:'1',
      endcol:'5',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'6',
      startcol:'3',
      endrow:'8',
      endcol:'5',
    }
  ]
},
{
  id: 22,
  name: 'Fischer - Dely, Skopje 1967',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 7 moves.',
  diagrams:{
    0:'r3kb1r/1p4pp/p3p3/8/1q1Qp3/4B3/PPP3PP/R4RK1',
    1:'r3kR1r/1p4pp/p3p3/8/1q1Qp3/4B3/PPP3PP/R5K1',
    2:'r3kq1r/1p4pp/p3p3/8/3Qp3/4B3/PPP3PP/R5K1',
    3:'r3kq1r/1p4pp/p3p3/8/Q3p3/4B3/PPP3PP/R5K1',
    4:'r3kq1r/6pp/p3p3/1p6/Q3p3/4B3/PPP3PP/R5K1',
    5:'r3kq1r/6pp/p3p3/1p6/4Q3/4B3/PPP3PP/R5K1',
    6:'3rkq1r/6pp/p3p3/1p6/4Q3/4B3/PPP3PP/R5K1',
    7:'3rkq1r/6pp/p1Q1p3/1p6/8/4B3/PPP3PP/R5K1',
    8:'4kq1r/3r2pp/p1Q1p3/1p6/8/4B3/PPP3PP/R5K1',
    9:'4kq1r/3r2pp/p1Q1p3/1p6/8/4B3/PPP3PP/3R2K1',
    10:'4k2r/3rq1pp/p1Q1p3/1p6/8/4B3/PPP3PP/3R2K1',
    11:'4k2r/3rq1pp/pBQ1p3/1p6/8/8/PPP3PP/3R2K1',
    12:'4kr2/3rq1pp/pBQ1p3/1p6/8/8/PPP3PP/3R2K1',
    13:'2Q1kr2/3rq1pp/pB2p3/1p6/8/8/PPP3PP/3R2K1',
  },
  comments:{
    0:'Fischer - Dely, Skopje 1967, White to move.',
    1:'1.Rxf8+!. Very good!',
    2:'1...Qxf8. On any other move Black would lose his Queen. What move would you play for White?',
    3:'2.Qa4+. Very good!',
    4:'2...b5. Here Black actually resigned. What move would you play for White?',
    5:'3.Qe4. Attacking the Black Rook.',
    6:'3...Rd8. What move would you play for White?',
    7:'4.Qc6+. Very good!',
    8:'4...Rd7. Otherwise Black loses his Queen: 4...Ke7 5.Bc5+ or 4...Kf8 5.Rf1+. What move would you play for White?',
    9:'5.Rd1. Very good!',
    10:'5...Qe7. Defending the Rook. What move would you play for White?',
    11:'6.Bb6. Very good! This is Fischer\'s suggestion. 6.Rd3 is also good: 6...h6 7.Bc5 Qf7 (7...Qxc5+ 8.Qxc5 White wins ) 8.Qc8+ Rd8 9.Qxd8#',
    12:'6...Rf8. What move would you play for White?',
    13:'7.Qc8+. Very good! White is winning.',
  },
  solution:[
    {
      startrow:'8',
      startcol:'6',
      endrow:'1',
      endcol:'6',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'4',
      endrow:'5',
      endcol:'1',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'1',
      endrow:'5',
      endcol:'5',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'5',
      endrow:'3',
      endcol:'3',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'8',
      startcol:'1',
      endrow:'8',
      endcol:'4',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'6',
      startcol:'5',
      endrow:'3',
      endcol:'2',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'3',
      startcol:'3',
      endrow:'1',
      endcol:'3',
    }
  ]
},
{
  id: 23,
  name: 'Fischer - Shocron, Mar del Plata 1959',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 3 moves.',
  diagrams:{
    0:'1r1q2k1/4bp1p/2R1n1p1/4p1P1/B1p1P1Q1/2P1B1P1/5PK1/8',
    1:'1r1q2k1/4bp1p/4R1p1/4p1P1/B1p1P1Q1/2P1B1P1/5PK1/8',
    2:'1rq3k1/4bp1p/4R1p1/4p1P1/B1p1P1Q1/2P1B1P1/5PK1/8',
    3:'1rq3k1/3Bbp1p/4R1p1/4p1P1/2p1P1Q1/2P1B1P1/5PK1/8',
    4:'r5k1/3qbp1p/4R1p1/4p1P1/2p1P1Q1/2P1B1P1/5PK1/8',
    5:'r5k1/3qbp1p/6R1/4p1P1/2p1P1Q1/2P1B1P1/5PK1/8',
  },
  comments:{
    0:'Fischer - Shocron, Mar del Plata 1959, White to move.',
    1:'1.Rxe6. Very good!',
    2:'1...Qc8. This would seem to win back the Rook due to the pin except White\'s next move refutes this. According to Fischer, 1...fxe6 2.Qxe6+ Kf8 3.Qxe5 is crushing. What move would you play for White?',
    3:'2.Bd7. Very good!',
    4:'2...Qxd7. Here Black actually resigned. What move would you play for White?',
    5:'3.Rxg6+. Winning the Black Queen by discovered check.',
  },
  solution:[
    {
      startrow:'3',
      startcol:'3',
      endrow:'3',
      endcol:'5',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'5',
      startcol:'1',
      endrow:'2',
      endcol:'4',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'3',
      startcol:'5',
      endrow:'3',
      endcol:'7',
    },
  ]
},
{
  id: 24,
  name: 'Fischer - Fine, New York 1963',
  featured: false,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Find the solution for White by moving the correct piece. You will need to find 3 moves.',
  diagrams:{
    0:'r1b1k1r1/pppp1pBp/8/b2P4/2B4q/1Q6/P4PP1/R4RK1',
    1:'r1b1k1r1/pppp1pBp/8/b2P4/2B4q/1Q6/P4PP1/R3R1K1',
    2:'r1bk2r1/pppp1pBp/8/b2P4/2B4q/1Q6/P4PP1/R3R1K1',
    3:'r1bk2r1/pppp1pBp/8/b2P4/2B4q/6Q1/P4PP1/R3R1K1',
    4:'r1bk2r1/pppp1pBp/8/b2P4/2B5/6q1/P4PP1/R3R1K1',
    5:'r1bk2r1/pppp1p1p/5B2/b2P4/2B5/6q1/P4PP1/R3R1K1',
  },
  comments:{
    0:'Fischer - Fine, New York 1963, White to move.',
    1:'1.Rfe1+. Very good!',
    2:'1...Kd8. It would make no difference if Black plays 1...Bxa1 2.Rxe1+. What move would you play for White?',
    3:'2.Qg3. Very good!',
    4:'2...Qxg3. Here Black actually resigned. What move would you play for White?',
    5:'3.Bf6+. Checkmate!',
  },
  solution:[
    {
      startrow:'8',
      startcol:'6',
      endrow:'8',
      endcol:'5',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'6',
      startcol:'2',
      endrow:'6',
      endcol:'7',
    },
    {
      startrow:'-1',
      startcol:'-1',
      endrow:'-1',
      endcol:'-1',
    },
    {
      startrow:'2',
      startcol:'7',
      endrow:'3',
      endcol:'6',
    },
  ]
}
];
